<template>
  <v-card flat>
    <v-dialog persistent v-if="type=='approve'" v-model="showDialog" max-width="400px">
      <v-card flat>
        <v-icon class="close" @click="cancel">$sl-close</v-icon>
        <h2>{{$t('application.approve-application')}}</h2>
        <v-card-text class="pl-0 pr-0">{{$t('application.approve-subtitle')}}</v-card-text>
        <v-card-actions class="d-flex justify-end mt-6">
          <ActionButton
            :block="false"
            type="application"
            actionIcon="$sl-cancel"
            @click="cancel"
          >{{ $t('labels.cancel') }}</ActionButton>
          <ActionButton
            :block="false"
            actionIcon="$sl-like"
            @click="approve"
          >{{ $t('labels.approve') }}</ActionButton>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="showDialog" v-if="type=='deny'" max-width="400px">
      <v-card flat>
        <v-icon class="close" @click="cancel">$sl-close</v-icon>
        <h2>{{$t('application.deny-application')}}</h2>
        <p v-html="$t('application.deny-application-text')"></p>
        <v-card-text class="pl-0 pr-0">
          <v-textarea
            outlined
            auto-grow
            v-model="notificationMessage"
            :label="$t('application.deny-subtitle')"
            type="text"
            class="mt-n3"
            textarea            
            persistent-hint
          ></v-textarea>
        </v-card-text>
        
        <ActionButton                      
          class="mt-n3"
          actionIcon="$sl-stop"
          @click="deny()"
        >{{ $t('labels.deny-application') }}</ActionButton>        

        <ActionButton            
          class="mt-6"
          type="application"
          actionIcon="$sl-cancel"
          @click="cancel"
        >{{ $t('labels.cancel') }}</ActionButton>
                
      </v-card>
    </v-dialog>

    <v-dialog persistent v-if="type=='delete'" v-model="showDialog" max-width="400px">
      <v-card flat>
        <v-icon class="close" @click="cancel">$sl-close</v-icon>
        <h2>{{$t('application.delete-title')}}</h2>
        <v-card-text class="pl-0 pr-0">
          {{$t('application.delete-question')}}
          <br />
          {{$t('application.delete-question2')}}
        </v-card-text>
        <v-card-actions class="d-flex justify-end mt-6">
          <ActionButton
            actionIcon="$sl-cancel"
            :block="false"
            @click="cancel"
          >{{ $t('labels.cancel') }}</ActionButton>
          <ActionButton
            :block="false"
            type="application"
            actionIcon="$sl-delete"
            @click.prevent="deleteApplication"
          >{{ $t('labels.delete') }}</ActionButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import ActionButton from '@/components/Common/ActionButton'

// @group Company
// AdminApplicationModal component
export default {
  name: 'AdminApplicationModal',

  props: {
    // Should modal be showed
    show: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    // application object
    application: {
      // `Object`
      type: Object,
      required: true
    },
    // fields type
    type: {
      // `string`
      type: String,
      required: true
    }
  },

  data: () => ({
    showDialog: false,
    notificationMessage: ''
  }),

  computed: {
    ...mapGetters('application', ['selectedApplication'])
  },

  watch: {
    /**
     * @vuese
     * Used to open modal
     */
    show() {
      this.showDialog = this.show
    }
  },

  created() {
    this.showDialog = this.show
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),
    /**
     * @vuese
     * Used to fetch the application based on applciation id and set it to the store
     * @arg The argument is integer values representing application id
     */
    getApplication(id) {
      if (!id) return

      API.getApplication(id)
        .then(response => {
          this.setSelectedApplication(response.data)
        })
        .catch(error => {
          console.log('There was an error get Application:', error)
        })
    },

    /**
     * @vuese
     * Used to update application
     * @arg The argument is integer values representing application id and sign true
     */
    approve() {
      if (this.application && this.application.id > 0) {
        API.updateApplication(this.application.id, {data: {sign: true}})
          .then(() => {
            this.$events.fire('showInfo', this.$t("application.approve"))
            this.getApplication(this.application.id) //get application from DB to get the new state and notifications
            //used to close the modal
            this.showDialog = false
            // Fire close modal
            // @arg The argument is a string
            this.$emit('close')
          })
          .catch(error => {
            this.$events.fire('showError', this.$t("application.error-text1"))
            console.log('There was an error:', error)
          })
      }
    },
    /**
     * @vuese
     * Used to deny application
     * @arg The argument is integer values representing application id , reject true and notifications
     */
    deny() {
      if (this.application && this.application.id > 0) {
        API.updateApplication(this.application.id, {
          data: {
            reject: true,
            notification: {notification: this.notificationMessage}
          }
        })
          .then(() => {
            this.getApplication(this.application.id) //get application from DB to get the notifications from back end
            this.$events.fire('showInfo', this.$t("application.deny"))
            //used to close the modal
            this.showDialog = false
            // Fire close modal
            // @arg The argument is a string
            this.$emit('close')
            setTimeout(() => {
                this.$router.push({name: 'CompanyApplications', params: {id: this.$route.params.id}})
              }, 1000)
          })
          .catch(error => {
            this.$events.fire('showError', this.$t("application.error-text1"))
            console.log('There was an error:', error)
          })
      }
    },
    /**
     * @vuese
     * Used to delete application
     * @arg The argument is integer values representing application id
     */
    deleteApplication() {
      if (this.application && this.application.id > 0) {
        API.deleteApplication(this.application.id)
          .then(response => {
            this.getApplication(this.application.id) //get application from DB to get the new state and notifications
            this.$events.fire('showInfo', this.$t("application.delete"))
            //used to close the modal
            this.showDialog = false
            // Fire close modal
            // @arg The argument is a string
            this.$emit('close')
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$events.fire('showError', this.$t('errors.text1'))
            } else {
              this.$events.fire('showError', this.$t('errors.text2'))
            }
            console.log('error code: ', error)
            //used to close the modal
            this.showDialog = false
            // Fire close modal
            // @arg The argument is a string
            this.$emit('close')
          })
      }
    },
    /**
     * @vuese
     * Used to cancel modal
     */
    cancel() {
      //used to close the modal
      this.showDialog = false
      // Fire close modal
      // @arg The argument is a string
      this.$emit('close')
    }
  },
  components: {
    ActionButton
  }
}
</script>

<style lang="scss">
</style>